import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
		timeTracking: -1,
		projects: -1,
		tasksMonoceros: -1,
		tasksJira: -1,
		statuses: -1,
		empList: -1,
		debts: -1,
		currentDate: new Date()
    },
	actions: {
		dateInputClick: (context, param) =>{
			context.commit('dateInputClick', param);
		},
		changeMonthDesc: (context, param) =>{
			context.commit('changeMonthDesc', param);
		},
		changeMonthAsc: (context, param) => {
			context.commit('changeMonthAsc', param);
		},
		changeCurrentDate: (context, param) =>{
			context.commit('changeCurrentDate', param);
		},
		changeDebts: (context, param) => {
			context.commit('changeDebts', param);
		},

		setTimeTracking: (context, param)=>{
			context.commit('setTimeTracking', param);
		},
		setProjects: (context, param) => {
			context.commit('setProjects', param);
		},
		setTasksMonoceros: (context, param) => {
			context.commit('setTasksMonoceros', param);
		},
		setTasksJira: (context, param) => {
			context.commit('setTasksJira', param);
		},
		setStatuses: (context, param) => {
			context.commit('setStatuses', param);
		},
		setDebts: (context, param) => {
			context.commit('setDebts', param);
		},

		changeTimeTracking: (context, param) => {
			context.commit('changeTimeTracking', param);
		},
		changeProjects: (context, param) => {
			context.commit('changeProjects', param);
		},
		changeTasksMonoceros: (context, param) => {
			context.commit('changeTasksMonoceros', param);
		},
		changeTasksJira: (context, param) => {
			context.commit('changeTasksJira', param);
		},
		setEmpList: (context, param) => {
			context.commit('setEmpList', param);
		}
	},
    mutations: {
		dateInputClick: (state, date) => {
			state.currentDate = date;
			state.timeTracking = -1;
			state.projects = -1;
			state.tasksMonoceros = -1;
			state.tasksJira = -1;
		},
		changeMonthDesc: (state, date) => {
			state.currentDate = date;
			state.timeTracking = -1;
			state.projects = -1;
			state.tasksMonoceros = -1;
			state.tasksJira = -1;
		},
		changeMonthAsc: (state, date) => {
			state.currentDate = date;
			state.timeTracking = -1;
			state.projects = -1;
			state.tasksMonoceros = -1;
			state.tasksJira = -1;
		},
		setTimeTracking: (state, params) =>{
			state.timeTracking = params;
		},
		setProjects: (state, params) => {
			state.projects = params;
		},
		setTasksMonoceros: (state, params) => {
			state.tasksMonoceros = params;
		},
		setTasksJira: (state, params)=>{
			state.tasksJira = params;
		},
		setStatuses:(state, params)=>{
			state.statuses = params;
		},
		setEmpList: (state, params) => {
			state.empList = params;
		},
		setDebts: (state, params) => {
			state.debts = params;
		},

		changeTimeTracking: (state) => {
			state.timeTracking = -1;
		},
		changeProjects: (state) => {
			state.projects = -1;
		},
		changeTasksMonoceros: (state) => {
			state.tasksMonoceros = -1;
		},
		changeTasksJira: (state) => {
			state.tasksJira = -1;
		},
		changeDebts: (state) => {
			state.debts = -1;
		}
    },
    getters: {
		statuses: (state) => {
			return state.statuses;
		},
		tasksJira:(state) =>{
			return state.tasksJira;
		},
		tasksMonoceros: (state) => {
			return state.tasksMonoceros;
		},
		timeTracking: (state) => {
			return state.timeTracking;
		},
		projects: (state) => {
			return state.projects;
		},
		currentDate: (state) =>{
			if (String(state.currentDate.getMonth() + 1).length == 1)
				return "0"+(state.currentDate.getMonth() + 1) + "-" + state.currentDate.getFullYear();
			else
				return (state.currentDate.getMonth() + 1) + "-" + state.currentDate.getFullYear() ;
		},
		empList: (state) => {
			return state.empList;
		},
		debts: (state) => {
			return state.debts;
		}
    }
  });


// WEBPACK FOOTER //
// ./src/store/store.js